import NoteTextEditor from './NoteTextEditor';

export default NoteTextEditor;
